<template>
  <v-app>
    <div class="header-unisinos" v-if="!$vuetify.breakpoint.mdAndUp && logged">
      <v-container class="py-1 my-0">
        <img src="//www.unisinos.br/images/logos/unisinos-logo-branco.svg" alt="Unisinos" style="height: 24px; padding: 0px 0px 0px" />
      </v-container>
    </div>
    <TheHeader v-if="$vuetify.breakpoint.mdAndUp && logged" />
    <v-main>
      <router-view></router-view>
    </v-main>
    <ThePopUp :sheet="true" />
    <TheTutorial />
    <TheError />
    <TheMobileMenu />
    <TheJourneyChange />

    <v-overlay :value="loading">
      <v-progress-circular indeterminate color="#7D4CA8" size="64"></v-progress-circular>
    </v-overlay>

    <TheFooter v-if="$vuetify.breakpoint.smAndDown && logged" />
  </v-app>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'
import TheMobileMenu from '@/components/TheMobileMenu'
import ThePopUp from '@/components/ThePopUp'
import TheTutorial from '@/components/TheTutorial'
import TheJourneyChange from '@/components/TheJourneyChange'
import TheError from '@/components/TheError'
import { mapState } from 'vuex'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    TheMobileMenu,
    ThePopUp,
    TheTutorial,
    TheError,
    TheJourneyChange,
  },
  computed: {
    ...mapState(['logged', 'popup', 'error', 'journeyDialog', 'journey', 'sequence', 'option', 'user', 'reset2', `resetQuiz`]),
    route() {
      return this.$route.path
    },
    experience() {
      if (!this.journey) {
        return 0
      }
      if (!this.journey.ideias || !this.journey.acoes || !this.journey.quiz) {
        return 0
      }

      let atualIdeias = (this.journey.ideias.atual * 100) / this.journey.ideias.meta
      let atualAcoes = (this.journey.acoes.atual * 100) / this.journey.acoes.meta
      let atualQuiz = (this.journey.quiz.atual * 100) / this.journey.quiz.meta

      if (atualIdeias > 100) atualIdeias = 100
      if (atualAcoes > 100) atualAcoes = 100
      if (atualQuiz > 100) atualQuiz = 100

      const final = atualIdeias / 3 + atualAcoes / 3 + atualQuiz / 3
      return Math.round(final)
    },
  },
  watch: {
    logged() {
      if (!this.logged) {
        this.jumped = true
        this.$router.push('/login')
      }
    },
    route() {
      let user = localStorage.getItem('user')
      if (user) {
        this.loadJourney()
      }

      if (user && !this.popup && !this.error && !this.setJourneyDialogInfo) {
        this.loadBonus()
      }
      this.executeQuiz()
    },
    journey() {
      if (this.journey && this.journey.etapa === 'escolhendo' && this.experience >= 100 && !this.theEnd) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text:
            'Estávamos ansiosos por esse momento! Parabéns, você concluiu a última etapa da sua jornada nesta plataforma. Mas não se preocupe, seguiremos ao seu lado por aqui. Agora é hora de ver as suas recompensas!',
          route: '/jornada#escolhendo',
          button: 'Vamos lá!',
        })
        this.theEnd = true
        localStorage.setItem('TheEnd', true)
      }
    },
    sequence() {
      if (this.sequence === false && this.logged) {
        this.loadJourney()
      }
    },
    option() {
      if (this.question) {
        if (this.option === 0) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text:
              '🎉 PARABÉNS! Você avançou na sua jornada, ficamos muito contentes com isso! Agora, você tem acesso a NOVOS conteúdos, recompensas e muito mais. MAS ATENÇÃO! Primeiro você precisa resgatar seus bônus e recompensas da jornada anterior.',
            button: [{ text: 'Já resgatei' }, { text: 'Resgatar Primeiro ', outlined: true }],
          })
          this.$store.dispatch('setOptionInfo', null)
          this.question = false
          this.changeSchooling = true
        }
        if (this.option === 1) {
          this.$router.push('/perfil')
          this.$store.dispatch('setOptionInfo', null)
          this.question = false
        }
        if (this.option === 2) {
          window.open('https://www.unisinos.br/graduacao/', '_BLANK')
          this.$store.dispatch('setOptionInfo', null)
          localStorage.removeItem('resetJourney')
          this.question = false
          this.loadJourney()
        }
      }
      if (this.changeSchooling) {
        if (this.option === 1) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Beleza, então vamos manter sua jornada atual! Mas você pode alterar sua escolaridade a qualquer momento e evoluir.',
            route: '/jornada',
          })
          this.$store.dispatch('setOptionInfo', null)
          this.changeSchooling = false
        }
        if (this.option === 0) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'Beleza! Agora você terá acesso a uma nova jornada cheia de novidades. Você terá acesso a novos conteúdos e experiências. Vem com a gente!',
          })
          this.resetJourney()
          this.$store.dispatch('setOptionInfo', null)
          this.changeSchooling = false
        }
      }
    },
    viewed() {
      if (this.viewed === true) {
        this.executeQuiz()
      }
    },
    reset2() {
      if (this.reset === true) {
        localStorage.removeItem('resetJourney')
        localStorage.removeItem('TheEnd')

        this.jumped = false
        this.journey2 = null
        this.theEnd = false
        this.quiz = []
        this.count = 0
        this.viewed = false
        this.etapa = null
        this.question = false
        this.changeSchooling = false
        this.loading = false
        window.location = '/conectameufuturo/'
      }
    },
    quiz() {
      if (this.sequence === false && this.logged) {
        this.executeQuiz()
      }
    },
  },
  data: () => ({
    jumped: false,
    journey2: null,
    theEnd: false,
    quiz: [],
    count: 0,
    viewed: false,
    etapa: null,
    question: false,
    changeSchooling: false,
    loading: false,
  }),
  methods: {
    loadUserSeassion() {
      let user = localStorage.getItem('user')
      if (!user) {
        this.jumped = true
      } else {
        this.$store.dispatch('setUserInfo', {
          user: JSON.parse(user),
        })
        this.loadJourney()
      }
    },
    loadJourney() {
      const url = `${baseApiUrl}/journey`
      this.etapa = null
      axios
        .get(url)
        .then((res) => {
          const jornada = res.data.journey
          this.$store.dispatch('setJourneyInfo', jornada)
          const rawJourney = localStorage.getItem('journey')
          let journeyOld = null
          if (rawJourney) {
            journeyOld = JSON.parse(rawJourney)
            if (journeyOld.etapa !== jornada.etapa) {
              this.$store.dispatch('setJourneyDialogInfo', { open: true })
            }
          } else {
            this.$store.dispatch('setJourneyDialogInfo', { open: true })
          }

          if (res.data.quiz) {
            this.checkQuiz()
            const obj = res.data.quiz
            this.quiz.push(obj)
            this.$store.dispatch('setFilaQuizInfo', this.quiz)
          }
          this.executeQuiz()

          localStorage.setItem('journey', JSON.stringify(jornada))

          if (jornada.new_material_available) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Chegaram novos conteúdos! Explore a plataforma para saber mais!',
            })
          }
          this.checkLastRewards(res.data.posts)
          this.dontHaveRewards(res.data.posts)
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
    loadBonus() {
      const url = `${baseApiUrl}/findAndDoBonuses`
      axios.get(url).then((res) => {
        if (res.data.success === true) {
          this.$store.dispatch('setErrorInfo', {
            open: true,
            text: 'OBA! Parece que você ganhou um bônus!',
            route: '/jornada#bonus',
            button: 'Vamos lá!',
          })
        }
      })
    },
    executeQuiz() {
      if (this.sequence === false && this.quiz.length > 0) {
        const q = this.quiz[0]
        this.quiz.shift()
        this.$store.dispatch('setPopupInfo', q)
      }
    },
    checkQuiz() {
      const tutorial = localStorage.getItem('tutorial')
      if (tutorial && this.logged && !this.viewed) {
        const rawTutorial = JSON.parse(tutorial)
        if (rawTutorial.steps[0].viewed === false) {
          rawTutorial.steps[0].viewed = true
          localStorage.setItem('tutorial', JSON.stringify(rawTutorial))
          this.viewed = true
          this.$store.dispatch('setTutorialInfo', {
            open: false,
            step: 0,
          })

          this.quiz.push({
            title:
              'Hey, Conecta escrevendo aqui! \\o Esse é o nosso quiz, ele vai aparecer conforme você interagir com a plataforma. Tudo pra gente saber se você tá curtindo a jornada e pra te conhecer melhor, beleza?',
            quiz_type: 'form',
            button_text: 'Continuar',
            ignore: true,
            description: '',
          })

          return true
        }
      }
      return false
    },
    checkLastRewards(posts) {
      Object.keys(posts).forEach((key) => {
        if (posts[key].rewards) {
          this.etapa = key
        }
      })
    },
    dontHaveRewards(posts) {
      const resetJourney = localStorage.getItem('resetJourney')
      const theEnd = localStorage.getItem('TheEnd')

      let end = false
      if (posts.experimentando && posts.descobrindo && posts.escolhendo && posts.explorando) {
        // Aqui Calcular Jornada
        if (posts.experimentando.conclusionsTotal && posts.descobrindo.conclusionsTotal && posts.escolhendo.conclusionsTotal && posts.explorando.conclusionsTotal) {
          let fechou = true
          if (posts.experimentando.bonusesTotal) {
            if (!posts.experimentando.bonusesTotalDone) {
              fechou = false
            }
            if (posts.experimentando.bonusesTotal > posts.experimentando.bonusesTotalDone) {
              fechou = false
            }
          }
          if (posts.descobrindo.bonusesTotal) {
            if (!posts.descobrindo.bonusesTotalDone) {
              fechou = false
            }
            if (posts.descobrindo.bonusesTotal > posts.descobrindo.bonusesTotalDone) {
              fechou = false
            }
          }
          if (posts.escolhendo.bonusesTotal) {
            if (!posts.escolhendo.bonusesTotalDone) {
              fechou = false
            }
            if (posts.escolhendo.bonusesTotal > posts.escolhendo.bonusesTotalDone) {
              fechou = false
            }
          }
          if (posts.explorando.bonusesTotal) {
            if (!posts.explorando.bonusesTotalDone) {
              fechou = false
            }
            if (posts.explorando.bonusesTotal > posts.explorando.bonusesTotalDone) {
              fechou = false
            }
          }
          if (!posts.experimentando.conclusionsTotalDone || !posts.explorando.conclusionsTotalDone || !posts.descobrindo.conclusionsTotalDone || !posts.escolhendo.conclusionsTotalDone) {
            fechou = false
          }

          if (posts.experimentando.conclusionsTotal > posts.experimentando.conclusionsTotalDone) {
            fechou = false
          }
          if (posts.descobrindo.conclusionsTotal > posts.descobrindo.conclusionsTotalDone) {
            fechou = false
          }
          if (posts.escolhendo.conclusionsTotal > posts.escolhendo.conclusionsTotalDone) {
            fechou = false
          }
          if (posts.explorando.conclusionsTotal > posts.explorando.conclusionsTotalDone) {
            fechou = false
          }
          // Se nada deu errado, deu boa
          if (fechou === true) {
            end = true
          }
        }
      }
      if (end && !resetJourney && theEnd) {
        this.question = true
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Você concluiu sua jornada aqui na plataforma, mas sabemos que isso não é o fim. Continue nos acompanhando, estamos sempre com novos conteúdos disponíveis.',
          button: [{ text: 'Recomeçar ', outlined: true }, { text: 'Ajustar minha escolaridade' }, { text: 'Ver os cursos da Uni' }],
        })
        localStorage.setItem('resetJourney', true)
      }
    },
    resetJourney() {
      this.loading = true
      const url = `${baseApiUrl}/saveUserData`
      const userNew = {
        email: this.user.email,
        reset_journey: 'full',
      }
      localStorage.removeItem('resetJourney')
      localStorage.removeItem('TheEnd')

      this.jumped = false
      this.journey2 = null
      this.theEnd = false
      this.quiz = []
      this.count = 0
      this.viewed = false
      this.etapa = null
      this.question = false
      this.changeSchooling = false
      this.loading = false

      const qs = require('qs')
      const object = qs.stringify(userNew)
      axios.post(url, object).then(() => {
        this.loading = false
        const h = window.location.href
        window.location.href = h
      })
    },
    checkBonus(el) {
      if (el.conclusionsTotal) {
        if (el.conclusionsTotalDone) {
          if (el.conclusionsTotal > el.conclusionsTotalDone) {
            return true
          }
        } else {
          return true
        }
      }
      if (el.bonusTotal) {
        if (el.bonusTotalDone) {
          if (el.bonusTotal > el.bonusTotalDone) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },
  },
  created() {
    this.loadUserSeassion()
    const end = localStorage.getItem('TheEnd')
    if (end) {
      this.theEnd = true
    }
  },
  mounted() {},
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');

html {
  overflow-y: auto;
}

.header-unisinos {
  background-color: rgba(26, 35, 89, 1);
  /* position: fixed; */
  top: 0;
  width: 100%;
  z-index: 1000;
}

.removeBorder .v-dialog {
  box-shadow: none !important;
}

.v-dialog {
  border-radius: 15px !important;
}

#app {
  background: #f3eeee !important;
}

.font-dm {
  font-family: 'DM Sans', sans-serif;
}

.v-btn {
  text-transform: none !important;
}

.color-white {
  color: #ffffff !important;
}

.color-purple {
  color: #502d7c !important;
}

.color-blue {
  color: #008fd2 !important;
}

.color-pink {
  color: #ff55a6 !important;
}

.rounded-un {
  border-radius: 15px !important;
}

.shaddow-un {
  /* -webkit-box-shadow: 0px 3px 15px 5px rgba(234,229,229,0.6) !important; 
  box-shadow: 0px 3px 15px 5px rgba(234,229,229,0.6) !important;
   */
  box-shadow: 0 9px 11px 0 rgba(0, 0, 0, 0.04) !important;
}
.fake-link {
  cursor: pointer;
}

.post-category {
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0px !important;
  display: block !important;
}

.post-title {
  font-size: 18px !important;
  font-weight: bold !important;
  letter-spacing: 0;
  line-height: 22px;
  display: block !important;
}

.post-footer {
  border-top: 1px solid #eeeeee;
  margin-top: 32px;
  padding-top: 40px;
}
.post-content {
  font-size: 14px !important;
  letter-spacing: 0;
  line-height: 18px !important;
}
.post-tag {
  color: #7d4ca8 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0;
  line-height: 18px;
  margin-right: 11px;
  text-decoration: none !important;
}

.input-un * {
  border: none !important;
  color: #502d7c !important;
  font-size: 14px !important;
  letter-spacing: 0 !important;
  line-height: 18px !important;
}

.cityfield .v-text-field--outlined .v-label--active {
  background: #ffffff !important;
  padding: 2px 8px !important;
  border-radius: 8px !important;
  color: #502d7c !important;
}

.category-text {
  font-size: 14px !important;
  letter-spacing: 0 !important;
  line-height: 18px !important;
}

.category-title {
  font-size: 30px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 39px !important;
}

.small-category .category-title {
  font-size: 18px !important;
}

.category-button {
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 21px !important;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ff55a6;
  position: absolute;
  right: 40px;
  bottom: 100%;
}
.arrow-up-purple {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #502d7c;
  position: absolute;
  right: 40px;
  bottom: 100%;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #ff55a6;
  position: absolute;
  right: 40px;
  top: 100%;
}

.arrow-down-purple {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #502d7c;
  position: absolute;
  right: 40px;
  top: 100%;
}

.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  position: absolute;
  left: 100%;
  top: 40px;
  border-left: 10px solid #ff55a6;
  margin-left: -1px;
}

.arrow-right-purple {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #502d7c;
  position: absolute;
  margin-left: -1px;
  left: 100%;
  top: 40px;
}

.arrow-left {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ff55a6;
  position: absolute;
  margin-right: -1px;
  right: 100%;
  top: 40px;
}

.arrow-left-purple {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #502d7c;
  position: absolute;
  right: 100%;
  margin-right: -1px;
  top: 40px;
}

.oval {
  position: absolute;
  left: 0px;
  top: -50px;
  height: 200px;
  width: 100%;
  background: radial-gradient(
    circle farthest-corner at 50% 0%,
    rgba(0, 144, 211, 0.5) 0%,
    rgba(0, 156, 148, 0.5) 20%,
    rgba(237, 111, 168, 0.3) 40%,
    rgba(229, 16, 61, 0) 60%,
    rgba(243, 238, 238, 1) 100%
  );
  background-position: top center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.oval-tap {
}

.fakeLink {
  cursor: pointer;
}

.infoPost {
  border-radius: 15px !important;
  box-shadow: 0 9px 11px 0 rgba(131, 97, 97, 0.04) !important;
}
.infoCategory {
  font-family: 'DM Sans' !important;
  color: #502d7c !important;
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 18px !important;
}

.infoTitle {
  color: #502d7c !important;
  font-family: 'DM Sans' !important;
  font-size: 14px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
}

.ctaButton {
}

.login-bottom-mobile {
  max-height: 100%;
  overflow-y: scroll;
}

.tutorial {
  position: absolute;
  width: 300px;
  z-index: 500;
  color: #ffffff !important;
}

.tutorialEnd {
  position: relative;
  z-index: 1;
}

.tutorialContent {
  z-index: 120 !important;
  background: #ff55a6;
}

.tutorialEndBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 10px;
  top: 10px;
  background: #502d7c;
  z-index: -20;
}

.tutorialEndRecompensa {
  color: #502d7c !important;
  font-family: 'DM Sans' !important;
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 21px !important;
}

.profile-title {
  font-size: 30px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 39px !important;
}

.backcard {
  margin-top: -60px !important;
}

.v-text-field--filled:not(.v-text-field--single-line) input {
  margin-top: 0px;
}

.register-subtitle {
  font-size: 14px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #7d4ca89d !important;
  color: #ffffff !important;
}

.login-container {
  position: relative !important;
  background-position: right center !important;
}

.login-container-mobile .v-image__image--cover {
  background-size: cover !important;
  background-position: bottom center !important;
}

.login-container .v-image__image--cover {
  background-position: left center !important;
  background-size: cover !important;
}

@media (max-width: 600px) {
  .profile-title {
    font-size: 18px !important;
    font-weight: bold !important;
    letter-spacing: 0 !important;
    line-height: 21px !important;
  }

  .tutorial {
    position: fixed;
  }
}

@media (min-width: 1903px) {
  .container {
    max-width: 1185px;
  }
}
</style>
